/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { ordersBotCallbackRequestSchema } from "./ordersBotCallbackRequestSchema.ts";

export const callbackTgConfirmedOrderCreateStatus200Schema = z.any();

export const callbackTgConfirmedOrderCreateResponseSchema = callbackTgConfirmedOrderCreateStatus200Schema;

export const callbackTgConfirmedOrderCreateDataSchemaJson = ordersBotCallbackRequestSchema;

export const callbackTgConfirmedOrderCreateDataSchemaXml = ordersBotCallbackRequestSchema;

export const callbackTgConfirmedOrderCreateDataSchema = z.union([callbackTgConfirmedOrderCreateDataSchemaJson, callbackTgConfirmedOrderCreateDataSchemaXml]);
